import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as fromActions from '../actions';
import { mergeMap, map } from 'rxjs/internal/operators';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Router } from '@angular/router';
import { AuthService } from '../../login/services/auth.service';
import { UserService } from '../../users/services/user.service';
import { PersistenceService, Keys } from '../../core/services/persistence.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { TranslateService } from '@ngx-translate/core';


@Injectable()
export class LoginEffects {
  private helper = new JwtHelperService();
  private translate: { error: string; success: string };
  constructor(
    private actions$: Actions,
    private authService: AuthService,
    private userService: UserService,
    private router: Router,
    private notificationService: NotificationService,
    private persistenseService: PersistenceService,
    private translateService: TranslateService
  ) {
  }

  login$ = createEffect(
    () => this.actions$.pipe(
      ofType(fromActions.login),
      mergeMap((action) => this.authService.login(action.credentials).pipe(
        tap((response) => {
          if (response && response.data && response.data.token)
            this.persistenseService.addValue(Keys.accessToken, response.data.token)
        }),
        switchMap((response) => {
          this.translateService.get("message.login").subscribe({
            next: (response) => this.translate = response
          });
          if (response['error']) {
            this.notificationService.error(this.translate.error);
            return of(fromActions.loginError({ error: response['message'] }))
          }
          else {
            this.notificationService.successful(this.translate.success);
            return [(fromActions.loginSuccess({ access_token: response.data.token }))]
          }
        }),
        catchError((error) => {
          return of(fromActions.loginError({ error }))
        })
      )),
    )
  );

  loginSuccess$ = createEffect(
    () => this.actions$.pipe(
      ofType(fromActions.loginSuccess),
      map((token) => (fromActions.findUser({ id: this.helper.decodeToken(token.access_token).uuid }))),
      catchError((error) => of(fromActions.loginError({ error })))
    ));

  findUser$ = createEffect(
    () => this.actions$.pipe(
      ofType(fromActions.findUser),
      mergeMap(
        (action) => this.userService.findById(action.id).pipe(
          switchMap((response) => [
            (fromActions.findUserSuccess({ user: response })),
          ]
          )
        )
      )
    ));

  setCurrentRole$ = createEffect(
    () => this.actions$.pipe(
      ofType(fromActions.setCurrentRole),
      tap((action) => this.persistenseService.addValue(Keys.role, JSON.stringify(action.role))),
      map(() => fromActions.goHome())
    ));

  goHome$ = createEffect(
    () => this.actions$.pipe(
      ofType(fromActions.goHome),
      tap(() => this.router.navigate(['/home'])
      )
    ),
    { dispatch: false }
  );

}
